export enum EScheduleTagType {
  SCHEDULE = "SCHEDULE",
  ESTIMATOR = "ESTIMATOR",
  ALL = "ALL",
}
